import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { setFinishScreenVisible, useLayoutDispatch } from '../../redux';
import {
	StyledBackground,
	StyledButtonsContainer,
	StyledCenterContainer,
	StyledClockIcon,
	StyledContainer,
	StyledTimerContainer,
} from './Confirmation.styled';

const Confirmation: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const otherPlayerName = useObservable(rage.exchange.getOtherPlayerName());
	const exchangeDelaySec = useObservable(rage.exchange.getExchangeDelaySec());
	const [time, setTime] = useState<number>(0);
	const isLocalPlayerConfirmedExchange = useObservable(
		rage.exchange.isLocalPlayerConfirmedExchange(),
	);

	const buttonDisabled = useMemo(
		() => exchangeDelaySec > 0 && time > 0,
		[exchangeDelaySec, time],
	);

	const handleConfirm = useCallback(async () => {
		if (buttonDisabled) {
			return;
		}

		await rage.exchange.confirmExchange();
		dispatch(setFinishScreenVisible(true));
	}, [buttonDisabled]);

	useEffect(() => {
		setTime(exchangeDelaySec);
	}, [exchangeDelaySec]);

	useEffect(() => {
		if (!time) return;
		const intervalId = setInterval(() => {
			setTime(time - 1);
		}, 1000);
		return () => clearInterval(intervalId);
	}, [time]);

	return (
		<StyledContainer>
			<StyledBackground />
			<StyledCenterContainer>
				<StyledTimerContainer>
					<StyledClockIcon />
					<Text>
						Идёт обмен с {otherPlayerName ?? 'игроком'}
						{time > 0 ? ` (${time} сек.)` : ''}
					</Text>
					<Text>
						Если вы не уверены в обмене, то нажмите на кнопку отмены ниже
					</Text>
				</StyledTimerContainer>
				<StyledButtonsContainer>
					<Button
						color={ButtonColors.Buy}
						height={ButtonHeight.Height40}
						disabled={buttonDisabled || isLocalPlayerConfirmedExchange}
						onClick={handleConfirm}
						style={{ width: 184 }}
					>
						<Text>
							{isLocalPlayerConfirmedExchange
								? 'Ожидание игрока'
								: 'Подтвердить обмен'}
						</Text>
					</Button>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height40}
						onClick={() => rage.exchange.exitExchange()}
					>
						<Text>Отменить обмен</Text>
					</Button>
				</StyledButtonsContainer>
			</StyledCenterContainer>
		</StyledContainer>
	);
};

export { Confirmation };
